export default {
  title: 'Interview Management',
  tab: 'INTERVIEW'
}
